import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { usePopper } from "react-popper";
import { ChevronRightIcon } from "@chakra-ui/icons";

const MenuItem = ({
  children,
  subMenu,
  setIsOpen,
  onClick,
  isDisabled,
  px = 2,
}) => {
  const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);

  const [trigger, setTrigger] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState(null);
  const { styles, attributes } = usePopper(trigger, popperElement, {
    modifiers: [],
    placement: "left-start",
  });

  return (
    <Flex
      textStyle={"bodyRegular"}
      _hover={
        !isDisabled
          ? {
              cursor: "pointer",
              bg: "bg.lighter",
            }
          : { cursor: "not-allowed" }
      }
      ref={subMenu && setTrigger}
      whiteSpace={"nowrap"}
      onMouseEnter={() => {
        if (subMenu) {
          setIsSubMenuOpen(true);
        }
      }}
      onMouseLeave={() => {
        if (subMenu) {
          setIsSubMenuOpen(false);
        }
      }}
      onClick={(e) => {
        if (onClick && !isDisabled) onClick(e);
        setIsOpen(false);
      }}
      bg={"transparent"}
      w={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box
        flexGrow={1}
        py={2}
        px={px}
        textAlign={"left"}
        {...(isDisabled && { color: "text.greyLight" })}
      >
        {children}
      </Box>
      {subMenu && (
        <Box pr={4}>
          <ChevronRightIcon boxSize={6} color={"icons.grey"} />
        </Box>
      )}

      {subMenu && !isDisabled && isSubMenuOpen && (
        <Box
          {...styles.popper}
          {...attributes.popper}
          ref={setPopperElement}
          zIndex={"dropdown"}
          mr={-3}
        >
          {React.cloneElement(subMenu, { setIsOpen })}
        </Box>
      )}
    </Flex>
  );
};

export default MenuItem;
